export const TELEMEDICINE_CONSENT_VERSION = 'TM-EC-2026-01';

export const telemedicineConsentClauses = [
  {
    id: 'remoteCare',
    title: 'Atencion remota',
    text: 'Acepto recibir atencion por telemedicina mediante audio, video, chat u otros medios digitales habilitados por la plataforma.',
  },
  {
    id: 'dataTreatment',
    title: 'Tratamiento de datos',
    text: 'Autorizo el tratamiento de mis datos personales y datos de salud para fines de atencion medica, registro clinico, seguimiento y trazabilidad asistencial.',
  },
  {
    id: 'telemedicineLimits',
    title: 'Limitaciones de la teleconsulta',
    text: 'Entiendo que la teleconsulta tiene limitaciones frente a la valoracion presencial y que el profesional puede recomendar atencion presencial o emergencia si lo considera necesario.',
  },
  {
    id: 'emergencyCriteria',
    title: 'Signos de alarma',
    text: 'Entiendo que sintomas graves como dolor toracico, dificultad respiratoria severa, perdida de conciencia, sangrado importante u otros signos de alarma requieren atencion urgente.',
  },
  {
    id: 'recordTraceability',
    title: 'Registro de aceptacion',
    text: 'Acepto que el sistema registre fecha, hora, usuario, cita, direccion IP si esta disponible, version del consentimiento y estado de aceptacion.',
  },
];

export const createEmptyConsentChecks = () => telemedicineConsentClauses.reduce((acc, clause) => ({
  ...acc,
  [clause.id]: false,
}), {});

export const allConsentClausesAccepted = (checks) => telemedicineConsentClauses
  .every((clause) => Boolean(checks[clause.id]));
